/** Every sharing entry point delivers an editable, recipient-owned Guide stage.
 * Rafael, 02.11.2026: this applies to existing Guide stages as well as free
 * workspaces. The former live-access/revocation dialog must not be selected by
 * the presence of a stage id. Existing access grants remain readable. */
import type { Model } from 'flexlayout-react';
import { ShareSnapshotStage } from './StageSharing';

export function ShareStageButton({ model, root, title }: { model: Model; root: () => HTMLElement | null; title: string; buehneId?: string }) {
  return <ShareSnapshotStage model={model} root={root} title={title} />;
}
